import React from 'react';

import { Container, Icon, Text, TextContainer } from './Badge.styled';

const Badge = () => {
  return (
    <Container>
      <Icon />
      <TextContainer>
        <Text>Dbam</Text>
        <Text>o siebie</Text>
        <Text>i bliskich</Text>
      </TextContainer>
    </Container>
  );
};

export default Badge;
